import { Cpu } from "lucide-react";

export function Logo({ className = "", showText = true, size = 20 }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="logo">
      <div
        className="flex items-center justify-center rounded-md bg-primary text-primary-foreground"
        style={{ width: size + 12, height: size + 12 }}
      >
        <Cpu size={size} strokeWidth={2} />
      </div>
      {showText && (
        <div className="leading-none">
          <span className="font-display text-lg font-semibold tracking-tight">Espresso</span>
          <span className="ml-1.5 hidden text-[10px] font-mono uppercase tracking-[0.2em] text-muted-foreground sm:inline">
            Knowledge Processor
          </span>
        </div>
      )}
    </div>
  );
}
